
function PaginaNaoEncontrada() {
    return (
        <div className="flex w-full h-[100vh]">
            <div className="grid w-full min-h-full place-items-center bg-background px-6 py-24 sm:py-32 lg:px-8">
                <div className="text-center">
                    <p className="text-base font-semibold text-primary">404</p>
                    <h1 className="font-display mt-4 text-5xl font-semibold tracking-tight text-balance text-foreground sm:text-7xl">Página não encontrada</h1>
                    <p className="mt-6 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">Desculpe, não conseguimos encontrar a página que você está procurando.</p>
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <a href="/" className="rounded-lg bg-primary px-3.5 py-2.5 text-sm font-semibold text-primary-foreground shadow-xs transition-colors duration-150 hover:brightness-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Ir para tela inicial</a>
                        <a href="/contato-suporte" className="text-sm font-semibold text-foreground transition-colors duration-150 hover:text-primary">Contatar o Suporte <span aria-hidden="true">&rarr;</span></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaginaNaoEncontrada;